/**
 * Notify Me UI fixes (10th Sept - final theme only)
 * - Hide Snapmint Pay EMI tiles when Notify Me is present
 * - On collection cards with Notify Me: keep it visible on hover; hide theme Sold out CTA
 * - Restore Notify Me click → email form (SB app leaves button dead when show_cfp_form=show_csp_button)
 * - If Notify Me is not on the product/card, leave existing theme + Snapmint behavior unchanged
 */
(function () {
  var NOTIFY_SELECTOR = '.csp-prod-button, button.bis, .bis.csp-prod-button';
  var SNAPMINT_SELECTOR =
    '#sm-widget-btn, .snap_emi_txt, .snap_emi_txt_wrapper, .snap_pdp_below_widget, .second_widget_btn';
  var CARD_SELECTOR = '.product-card-wrapper, .wishlist-card-wrapper';
  var RESTOCK_NOTIFY_SELECTOR = '.restock-rocket-button-product, .restock-rocket-button-collection, .restock-rocket-button-container .restock-rocket-button';
  var RESTOCK_PREORDER_SELECTOR = '.restock-rocket-preorder-button';
  var HIDDEN_ATTR = 'data-sr-hidden-for-notify';
  var STYLE_ID = 'sr-notify-me-ui-fix-style';
  var OPENED_ATTR = 'data-sr-notify-form-open';

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      'html.has-notify-me #sm-widget-btn,',
      'html.has-notify-me .snap_emi_txt,',
      'html.has-notify-me .snap_emi_txt_wrapper,',
      'html.has-notify-me .snap_pdp_below_widget,',
      'html.has-notify-me .second_widget_btn { display: none !important; }',
      '.product-card-wrapper.has-notify-me:hover .card__heading,',
      '.product-card-wrapper.has-notify-me:hover .card-information,',
      '.product-card-wrapper.has-notify-me:hover .products_variant_wrapper,',
      '.wishlist-card-wrapper.has-notify-me:hover .card__heading,',
      '.wishlist-card-wrapper.has-notify-me:hover .card-information,',
      '.wishlist-card-wrapper.has-notify-me:hover .products_variant_wrapper { opacity: 1 !important; }',
      '.product-card-wrapper.has-notify-me:hover .card__content .quick-add__submit,',
      '.wishlist-card-wrapper.has-notify-me:hover .quick-add__submit { display: none !important; }',
      '.product-card-wrapper.has-notify-me #sm-widget-btn,',
      '.product-card-wrapper.has-notify-me .snap_emi_txt,',
      '.product-card-wrapper.has-notify-me .snap_emi_txt_wrapper,',
      '.wishlist-card-wrapper.has-notify-me #sm-widget-btn,',
      '.wishlist-card-wrapper.has-notify-me .snap_emi_txt { display: none !important; }',
      /* Keep injected BIS on-page form usable next to the CTA */
      '.csp-prod-wrapper-detailpage.product-form-check.form-csp-div {',
      '  display: block !important;',
      '  width: 100%;',
      '  margin: 1rem 0 0;',
      '  position: relative;',
      '  z-index: 2;',
      '}',
      '.csp-prod-wrapper-detailpage.product-form-check .csp-prod-form { display: block !important; }',
      '.csp-prod-wrapper-detailpage.product-form-check .c-form__input {',
      '  width: 100%;',
      '  box-sizing: border-box;',
      '  margin: 0.5rem 0;',
      '  padding: 0.8rem 1rem;',
      '}',
      /* BIS on_popup layout injects a hidden .sb-product-form.sb-modal — force it open */
      '.sb-product-form.sb-modal.sr-notify-modal-open {',
      '  display: flex !important;',
      '  align-items: center;',
      '  justify-content: center;',
      '  position: fixed !important;',
      '  inset: 0;',
      '  z-index: 99999;',
      '  background: rgba(0,0,0,0.45);',
      '}',
      '.sb-product-form.sb-modal.sr-notify-modal-open .csp-prod-form,',
      '.sb-product-form.sb-modal.sr-notify-modal-open .product-form-check {',
      '  display: block !important;',
      '  background: #fff;',
      '  max-width: 420px;',
      '  width: calc(100% - 2rem);',
      '  padding: 1.25rem;',
      '  margin: 0 auto;',
      '}',
      '.sb-product-form.sb-modal.sr-notify-modal-open .c-form__input {',
      '  width: 100%;',
      '  box-sizing: border-box;',
      '  margin: 0.5rem 0;',
      '  padding: 0.8rem 1rem;',
      '}',
    ].join('\n');
    document.head.appendChild(style);
  }

  function isNotifyEl(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.matches && el.matches(NOTIFY_SELECTOR)) return true;
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    return el.tagName === 'BUTTON' && /^notify\s*me$/i.test(text);
  }

  function findNotify(root) {
    if (!root || !root.querySelectorAll) return null;
    var nodes = root.querySelectorAll(NOTIFY_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (isVisible(nodes[i])) return nodes[i];
    }
    var buttons = root.querySelectorAll('button');
    for (var j = 0; j < buttons.length; j++) {
      if (isNotifyEl(buttons[j]) && isVisible(buttons[j])) return buttons[j];
    }
    return null;
  }

  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    return true;
  }

  function hideSnapmint(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var nodes = scope.querySelectorAll(SNAPMINT_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el.getAttribute(HIDDEN_ATTR)) {
        el.setAttribute(HIDDEN_ATTR, el.style.display || '');
      }
      el.style.setProperty('display', 'none', 'important');
    }
  }

  function restoreSnapmint(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var nodes = scope.querySelectorAll('[' + HIDDEN_ATTR + ']');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var prev = el.getAttribute(HIDDEN_ATTR);
      el.style.removeProperty('display');
      if (prev) el.style.display = prev;
      el.removeAttribute(HIDDEN_ATTR);
    }
  }

  function hasVisibleButton(root, selector) {
    if (!root || !root.querySelectorAll) return false;
    var buttons = root.querySelectorAll(selector);
    for (var i = 0; i < buttons.length; i++) {
      if (isVisible(buttons[i])) return true;
    }
    return false;
  }

  function unlockBox(el) {
    if (!el || el.nodeType !== 1) return;
    if (
      el.style.position === 'static' &&
      el.style.height === 'auto' &&
      el.style.maxHeight === 'none' &&
      el.style.overflow === 'visible'
    ) {
      return;
    }
    el.style.setProperty('position', 'static', 'important');
    el.style.setProperty('display', 'block', 'important');
    el.style.setProperty('width', '100%', 'important');
    el.style.setProperty('height', 'auto', 'important');
    el.style.setProperty('max-height', 'none', 'important');
    el.style.setProperty('overflow', 'visible', 'important');
    el.style.setProperty('visibility', 'visible', 'important');
  }

  function preorderNoteText(plan) {
    if (!plan) return '';
    if (plan.preorder_button_description_enabled && plan.preorder_button_description) {
      return String(plan.preorder_button_description);
    }
    if (plan.preorder_button_description_show_quantity_limit && plan.quantity_limit_text) {
      var limitText = String(plan.quantity_limit_text);
      if (limitText.indexOf('{{') === -1) return limitText;
    }
    if (plan.preorder_button_description_show_shipping && plan.shipping_text) {
      var shippingText = String(plan.shipping_text);
      if (shippingText.indexOf('{{') === -1) return shippingText;
    }
    return '';
  }

  function fillPreorderNote(note) {
    var details = note.querySelector('.preorder-description-details');
    if (!details || details.getAttribute('data-hp33-preorder-filled') === 'true') return;
    if (details.childElementCount > 0 || (details.textContent && details.textContent.trim())) return;
    var rr = window._RestockRocket;
    var plan = rr && typeof rr.getSellingPlan === 'function' ? rr.getSellingPlan() : null;
    var text = preorderNoteText(plan);
    if (!text) return;
    var item = document.createElement('div');
    item.className = 'preorder-detail-item';
    if (plan.preorder_button_description_text_color) {
      item.style.color = plan.preorder_button_description_text_color;
    }
    var span = document.createElement('span');
    span.className = 'preorder-detail-text';
    span.textContent = text;
    item.appendChild(span);
    details.appendChild(item);
    details.setAttribute('data-hp33-preorder-filled', 'true');
    details.style.setProperty('display', 'flex', 'important');
  }

  function expandPreorderNote(productInfo) {
    if (!productInfo || !productInfo.querySelectorAll) return;
    var notes = productInfo.querySelectorAll('.restock-rocket-preorder-description');
    if (!notes.length) return;

    for (var i = 0; i < notes.length; i++) {
      var note = notes[i];
      var block = note.closest('.main-checkout-buttons');
      var buttons = block && block.querySelector('.product-form__buttons');
      var host = note.closest('.restock-rocket-wrapper, .restock-rocket-wrapper-inline') || note;
      if (buttons && host.parentElement !== buttons && !host.querySelector('[name="add"]')) {
        buttons.appendChild(host);
      }
      fillPreorderNote(note);
      unlockBox(host);
      if (host !== note) unlockBox(note);
    }

    var shells = productInfo.querySelectorAll(
      '.main-checkout-buttons, .product-form, .product-form__buttons, .product-form__buttons-row'
    );
    for (var j = 0; j < shells.length; j++) {
      var shell = shells[j];
      if (shell.style.height === 'auto' && shell.style.overflow === 'visible' && shell.style.maxHeight === 'none') {
        continue;
      }
      shell.style.setProperty('height', 'auto', 'important');
      shell.style.setProperty('max-height', 'none', 'important');
      shell.style.setProperty('overflow', 'visible', 'important');
    }
  }

  function syncPage() {
    ensureStyles();
    var productInfo = document.querySelector('.product__info-container');
    var pageHasRestockNotify = hasVisibleButton(productInfo, RESTOCK_NOTIFY_SELECTOR);
    var pageHasRestockPreorder = hasVisibleButton(productInfo, RESTOCK_PREORDER_SELECTOR);
    var pageHasNotify = !!findNotify(productInfo);
    document.documentElement.classList.toggle('has-notify-me', pageHasNotify);
    document.documentElement.classList.toggle('has-restock-notify', pageHasRestockNotify);
    document.documentElement.classList.toggle('has-restock-preorder', pageHasRestockPreorder);

    if (pageHasNotify) {
      hideSnapmint(productInfo);
    } else {
      restoreSnapmint(productInfo);
    }

    expandPreorderNote(productInfo);

    var cards = document.querySelectorAll(CARD_SELECTOR);
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var cardHasNotify = !!findNotify(card);
      var cardHasRestockNotify = hasVisibleButton(card, RESTOCK_NOTIFY_SELECTOR);
      var cardHasRestockPreorder = hasVisibleButton(card, RESTOCK_PREORDER_SELECTOR);
      card.classList.toggle('has-notify-me', cardHasNotify);
      card.classList.toggle('has-restock-action', cardHasRestockNotify || cardHasRestockPreorder);
      if (cardHasNotify) {
        hideSnapmint(card);
      } else {
        restoreSnapmint(card);
      }
    }
  }

  var scheduled = false;
  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      syncPage();
    });
  }

  function getBisSettings() {
    if (typeof window.whichExtArr === 'function') {
      try {
        return window.whichExtArr('bis') || {};
      } catch (e) {
        /* ignore */
      }
    }
    return (
      window.backInStockSettings ||
      (window.comingSoonSettings && window.comingSoonSettings.backInStockSetting) ||
      {}
    );
  }

  function getBisLabels(extArr) {
    if (typeof window.bisSBSelLan === 'object' && window.bisSBSelLan) return window.bisSBSelLan;
    return {
      'form-title': extArr.title || 'Notify Me',
      'form-subtitle': extArr['csp-form-subtitle'] || '',
      'email-placeholder': extArr.email_placeholder || 'Your email address',
      'submit-title': extArr.submit || 'Notify Me',
    };
  }

  function extractProductId(btn) {
    var className = String(btn.className || '');
    var m = className.match(/collection-form-sb-btn-(\d+)/);
    if (m) return m[1];
    var wrap = btn.closest('.csp-prod-wrapper-detailpage, [class*="csp-prod"]');
    if (wrap) {
      m = String(wrap.className || '').match(/\b(\d{8,})\b/);
      if (m) return m[1];
    }
    if (window.sb_csp_product_id) return String(window.sb_csp_product_id);
    return '';
  }

  function resolveProductContext(btn) {
    var card = btn.closest(CARD_SELECTOR + ', .card-wrapper, .grid__item');
    var isCollection = !!(card && !location.pathname.includes('/products/'));
    var prodId = extractProductId(btn);
    var handle = '';
    var title = '';
    var img = '';

    if (isCollection && card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (link) {
        var parts = (link.getAttribute('href') || '').split('/products/');
        handle = (parts[1] || '').split('?')[0].split('#')[0];
      }
      var heading = card.querySelector('.card__heading, .card__title, h3, h2');
      title = heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
      var image = card.querySelector('img');
      img = image ? image.currentSrc || image.src || '' : '';
    } else {
      handle =
        window.sb_csp_product_handle ||
        (location.pathname.split('/products/')[1] || '').split('?')[0].split('#')[0];
      var titleEl = document.querySelector('.product__title, h1.product-title, h1');
      title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : document.title;
      var media = document.querySelector('.product__media img, media-gallery img, .product-media-container img');
      img = media ? media.currentSrc || media.src || '' : '';
      if (!prodId && window.sb_csp_product_id) prodId = String(window.sb_csp_product_id);
    }

    return {
      isCollection: isCollection,
      prodId: prodId,
      handle: handle,
      title: title || handle,
      img: img,
      url: (window.shopMainUrl || location.origin) + '/products/' + handle,
    };
  }

  function buildFormHtml(ctx) {
    if (typeof window.getCreateForm !== 'function') return null;
    var extArr = getBisSettings();
    var labels = getBisLabels(extArr);
    var emailField =
      '<input class="c-form__input" placeholder="' +
      (labels['email-placeholder'] || 'Your email address') +
      '" id="cspemail" type="email" required>';
    var dataReturn = {
      productData: {
        id: ctx.prodId,
        title: ctx.title,
        handle: ctx.handle,
        featured_image: ctx.img,
        images: ctx.img ? [{ src: ctx.img }] : [],
      },
      variants: '',
    };
    var pageType = ctx.isCollection ? 'collection' : 'pdp_page';
    var formType = ctx.isCollection ? 'on_popup' : extArr.form_layout_type || 'on_page';
    return window.getCreateForm(
      pageType,
      'bis',
      formType,
      ctx.prodId,
      ctx.url,
      ctx.prodId,
      dataReturn,
      ctx.handle,
      ctx.title,
      labels['form-title'] || extArr.title || 'Notify Me',
      labels['form-subtitle'] || '',
      '',
      '',
      emailField,
      '',
      '',
      '',
      labels['submit-title'] || extArr.submit || 'Notify Me',
      ''
    );
  }

  function markSubmitAsBis(root) {
    if (!root || !root.querySelectorAll) return;
    var nodes = root.querySelectorAll('.submitReq');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.add('bis');
    }
  }

  /* Product ids are numeric classes — cannot use .class.123 in querySelector */
  function findByNumericClass(root, baseClass, prodId) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('.' + baseClass);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].classList.contains(prodId)) return nodes[i];
    }
    return null;
  }

  function ensureCollectionModal() {
    var modal = document.querySelector('.sb-collection-form');
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'sb-collection-form sb-modal';
      document.body.appendChild(modal);
    }
    return modal;
  }

  function findPdpModalShell(fromNode) {
    if (!fromNode || !fromNode.closest) return null;
    return fromNode.closest('.sb-product-form.sb-modal, .sb-modal.sb-product-form');
  }

  function revealPdpForm(formNode, btn) {
    if (!formNode) return false;
    formNode.style.setProperty('display', 'block', 'important');
    var form = formNode.querySelector('.csp-prod-form');
    if (form) form.style.setProperty('display', 'block', 'important');

    var shell = findPdpModalShell(formNode);
    if (shell) {
      shell.classList.add('sr-notify-modal-open');
      shell.style.setProperty('display', 'flex', 'important');
      document.body.style.overflow = 'hidden';
      bindPdpModalClose(shell);
    }

    if (btn) {
      btn.style.setProperty('display', 'none', 'important');
      btn.setAttribute(OPENED_ATTR, '1');
    }
    markSubmitAsBis(shell || formNode);
    return true;
  }

  function bindPdpModalClose(shell) {
    if (!shell || shell.getAttribute('data-sr-close-bound')) return;
    shell.setAttribute('data-sr-close-bound', '1');

    function closeModal() {
      shell.classList.remove('sr-notify-modal-open');
      shell.style.setProperty('display', 'none', 'important');
      document.body.style.overflow = '';
      /* Restore Notify Me trigger buttons on this PDP */
      var triggers = document.querySelectorAll(
        'button.csp-prod-button.bis[' + OPENED_ATTR + '], button.csp-prod-button[' + OPENED_ATTR + ']'
      );
      for (var i = 0; i < triggers.length; i++) {
        if (triggers[i].classList.contains('submitReq')) continue;
        triggers[i].style.removeProperty('display');
        triggers[i].removeAttribute(OPENED_ATTR);
      }
    }

    var closeBtn = shell.querySelector('.close-sb-modal, .close-product-modal');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
      });
    }
    shell.addEventListener('click', function (e) {
      if (e.target === shell) closeModal();
    });
  }

  function openNotifyForm(btn) {
    if (!btn || btn.classList.contains('submitReq')) return false;
    if (typeof window.getCreateForm !== 'function') return false;

    var ctx = resolveProductContext(btn);
    if (!ctx.prodId || !ctx.handle) return false;

    /* Collection: reuse app modal shell */
    if (ctx.isCollection) {
      var html = buildFormHtml(ctx);
      if (!html) return false;
      var modal = ensureCollectionModal();
      modal.innerHTML = html;
      modal.style.display = 'flex';
      var inner = findByNumericClass(modal, 'collection-form', ctx.prodId);
      if (inner) inner.style.display = 'inline-block';
      document.body.style.overflow = 'hidden';
      markSubmitAsBis(modal);
      bindCollectionModalClose(modal, ctx.prodId);
      btn.setAttribute(OPENED_ATTR, '1');
      return true;
    }

    /* PDP: if form already present, reveal it (including hidden on_popup shell) */
    var existing =
      findByNumericClass(document, 'product-form-check', ctx.prodId) ||
      findByNumericClass(document, 'form-csp-div', ctx.prodId);
    if (existing) {
      return revealPdpForm(existing, btn);
    }

    var pdpHtml = buildFormHtml(ctx);
    if (!pdpHtml) return false;
    var wrap = btn.closest('.csp-prod-wrapper-detailpage') || btn.parentElement;
    if (!wrap) return false;
    wrap.insertAdjacentHTML('afterend', pdpHtml);
    var injected =
      findByNumericClass(document, 'product-form-check', ctx.prodId) ||
      findByNumericClass(document, 'form-csp-div', ctx.prodId);
    return revealPdpForm(injected, btn);
  }

  function bindCollectionModalClose(modal, prodId) {
    function closeModal() {
      modal.style.display = 'none';
      modal.innerHTML = '';
      document.body.style.overflow = '';
    }
    var closeBtn = null;
    var buttons = modal.querySelectorAll('button, [class*="close-modal"], .close-sb-modal');
    for (var i = 0; i < buttons.length; i++) {
      var cls = buttons[i].classList;
      if (cls.contains('close-sb-modal') || cls.contains('close-modal-' + prodId)) {
        closeBtn = buttons[i];
        break;
      }
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
      });
    }
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
  }

  function isDeadNotifyTrigger(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.classList.contains('submitReq')) return false;
    if (el.closest('.csp-prod-form, .product-form-check, .sb-collection-form .csp-prod-form')) return false;
    var isBisButton =
      el.matches &&
      (el.matches('button.csp-prod-button.bis') ||
        el.matches('button.collection-form-sb-btn.bis') ||
        el.matches('button.csp-prod-button') ||
        el.matches('button.collection-form-sb-btn'));
    if (!isBisButton) return false;
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    return /^notify\s*me$/i.test(text) || el.classList.contains('bis');
  }

  function onDocumentClick(e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var btn = target.closest('button.csp-prod-button, button.collection-form-sb-btn, button.bis');
    if (!isDeadNotifyTrigger(btn)) return;

    /* App intentionally wires no handler when show_cfp_form === show_csp_button */
    var opened = openNotifyForm(btn);
    if (opened) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  function initClickFix() {
    document.addEventListener('click', onDocumentClick, true);
  }

  function init() {
    ensureStyles();
    syncPage();
    initClickFix();
    var observer = new MutationObserver(scheduleSync);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
